import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    height="100%"
    width="100%"
    viewBox="0 0 108.6 58.9"
    style={{ enableBackground: "new 0 0 112.7 58.9" }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{`.st0{fill:none;stroke:${strokeColor};stroke-miterlimit:10;}`}</style>
    <g>
      <g>
        <g>
          <g>
            <line className="st0" x1="98.9" y1="32.3" x2="72.2" y2="47.7" />
            <line className="st0" x1="73.6" y1="44.5" x2="98.9" y2="31" />
            <path className="st0" d="M72.9,0.7c-2,1.1-6.6,16.3-6.6,16.3" />
            <path className="st0" d="M38.4,0.6c-2.9,0.7-12.4,12.5-12,12.7" />
            <path className="st0" d="M38.3,0.7C38.3,0.5,61,0.5,73,0.8" />
            <path className="st0" d="M66.4,16.8c-0.6,1-24.9-0.4-40-3.5" />
            <path className="st0" d="M1.7,29.5c1-8.4,12.1-11.4,24.7-16.2" />
            <path className="st0" d="M61.8,54.7c-19.1,8.1-46.5-2.8-58.7-6.6" />
            <path className="st0" d="M1.7,29.2c-1.8,11.1,0.9,19.2,1.6,18.9" />
            <path className="st0" d="M106.6,22.8c0.6-4.3-0.3-11.3-1.2-11.3" />
          </g>
          <path className="st0" d="M108,20.7c-0.1,4.8-0.7,4.7-2,5.5" />
          <ellipse className="st0" cx="68" cy="48.7" rx="4.1" ry="9.5" />
          <path className="st0" d="M64.9,38.9c1.8-4,7.1-5.9,7.8,8.6" />
          <path className="st0" d="M61.7,55c0-14.5,2.1-22.5,7.1-22.1" />
          <path className="st0" d="M73.5,47.1c0-7.7-0.2-13.6-4.7-14.2" />
          <path className="st0" d="M62,46.6c1.3-4.4,2.6-7.2,3.1-8.1" />
          <path className="st0" d="M59,55.9c0.6,1.2,0.5,2.5,2.9,2.6" />
          <path className="st0" d="M69.2,57.6c0,0.8-4.3,0.9-7.5,0.9" />
          <ellipse className="st0" cx="103.2" cy="27.4" rx="2.6" ry="7.5" />
          <path className="st0" d="M95.8,33.8c0.3,1.5,1.4,1.5,2.6,1.5" />
          <line className="st0" x1="103.2" y1="35.1" x2="98.2" y2="35.4" />
          <path className="st0" d="M98.6,32.6c0.6-9.2,0.8-16.6,4.5-17" />
          <path className="st0" d="M106.5,25.9c0.6-9.4-1.7-10.6-3.6-10.3" />
          <path className="st0" d="M100.6,26.6c-1.5-6.5,3.5-14,6-5.1" />
          <ellipse className="st0" cx="103.2" cy="28" rx="0.6" ry="1.4" />
          <ellipse className="st0" cx="67.9" cy="49.4" rx="0.9" ry="1.9" />
        </g>
      </g>
    </g>

    {/* Standalone lines and paths */}
    <line className="st0" x1="68" y1="39.2" x2="67.9" y2="47.5" />
    <line className="st0" x1="64.2" y1="45.1" x2="67.3" y2="48.1" />
    <line className="st0" x1="68.8" y1="50.2" x2="71.6" y2="53.3" />
    <line className="st0" x1="71.9" y1="45.5" x2="71.9" y2="45.5" />
    <line className="st0" x1="67.9" y1="51.3" x2="68" y2="58.2" />
    <line className="st0" x1="67.1" y1="50" x2="63.9" y2="51.3" />
    <line className="st0" x1="68.7" y1="48.7" x2="72.1" y2="47.1" />
    <line className="st0" x1="103.2" y1="19.9" x2="103.2" y2="26.6" />
    <line className="st0" x1="103.2" y1="29.5" x2="103.5" y2="34.5" />
    <path className="st0" d="M105.8,28" />
    <path className="st0" d="M104.2,28" />
    <line className="st0" x1="102.6" y1="28.9" x2="101.1" y2="30.7" />
    <line className="st0" x1="105.4" y1="24.1" x2="103.8" y2="27.4" />
    <line className="st0" x1="103.9" y1="28.5" x2="105.6" y2="29.9" />
    <line className="st0" x1="100.9" y1="25.4" x2="102.6" y2="27.7" />
  </svg>
);
export default SvgComponent;
